import { interpolateText } from "./interpolation";
import type { TuOptions } from "./types";

export function fallbackTu(defaultText: string, options?: TuOptions): string {
  return interpolateText(defaultText, options?.values);
}
